module.exports = __webpack_public_path__ + "static/img/gradient.29c327f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/gradient.png
// module id = i1Lk
// module chunks = 0